// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../Poppins.scss";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/proxima-nova-regular/proximanova-regular-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../font/proxima-nova-light/proximanova-light-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../font/proxima-nova-semi-bold/ProximaNova-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../font/proxima-nova-bold/proximanova-bold-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#proxima_novaregular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#proxima_novalight" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#proxima_novabold" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-family: PoppinsRegular; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

body {
  margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  box-sizing: content-box;
  height: 0;
}

/**
 * Contain overflow in all browsers.
 */
pre {
  overflow: auto;
}

/**
 * Address odd \`em\`-unit font size rendering in all browsers.
 */
code,
kbd,
pre,
samp {
  font-family: PoppinsRegular;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit; /* 1 */
  font: inherit; /* 2 */
  margin: 0; /* 3 */
}

/**
 * Address \`overflow\` set to \`hidden\` in IE 8/9/10/11.
 */
button {
  overflow: visible;
}

/**
 * Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
 * All other form control elements do not inherit \`text-transform\` values.
 * Correct \`button\` style inheritance in Firefox, IE 8/9/10/11, and Opera.
 * Correct \`select\` style inheritance in Firefox.
 */
button,
select {
  text-transform: none;
}

/**
 * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
 *    and \`video\` controls.
 * 2. Correct inability to style clickable \`input\` types in iOS.
 * 3. Improve usability and consistency of cursor style between image-type
 *    \`input\` and others.
 */
button,
html input[type=button],
input[type=reset],
input[type=submit] {
  -webkit-appearance: button; /* 2 */
  cursor: pointer; /* 3 */
}

/**
 * Re-set default cursor for disabled elements.
 */
button[disabled],
html input[disabled] {
  cursor: default;
}

/**
 * Remove inner padding and border in Firefox 4+.
 */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/**
 * Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
 * the UA stylesheet.
 */
input {
  line-height: normal;
}

/**
 * It's recommended that you don't attempt to style these elements.
 * Firefox's implementation doesn't respect box-sizing, padding, or width.
 *
 * 1. Address box sizing set to \`content-box\` in IE 8/9/10.
 * 2. Remove excess padding in IE 8/9/10.
 */
input[type=checkbox],
input[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Fix the cursor style for Chrome's increment/decrement buttons. For certain
 * \`font-size\` values of the \`input\`, it causes the cursor style of the
 * decrement button to change from \`default\` to \`text\`.
 */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
 * 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome
 *    (include \`-moz\` to future-proof).
 */
input[type=search] {
  -webkit-appearance: textfield; /* 1 */ /* 2 */
  box-sizing: content-box;
}

/**
 * Remove inner padding and search cancel button in Safari and Chrome on OS X.
 * Safari (but not Chrome) clips the cancel button when the search input has
 * padding (and \`textfield\` appearance).
 */
input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Define consistent border, margin, and padding.
 */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct \`color\` not being inherited in IE 8/9/10/11.
 * 2. Remove padding so people aren't caught out if they zero out fieldsets.
 */
legend {
  border: 0; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Remove default vertical scrollbar in IE 8/9/10/11.
 */
textarea {
  overflow: auto;
}

/**
 * Don't inherit the \`font-weight\` (applied by a rule above).
 * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
 */
optgroup {
  font-weight: bold;
}

/* Tables
   ========================================================================== */
/**
 * Remove most spacing between table cells.
 */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novalight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novasemibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "proxima_novabold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Core ----------------------- */
/* Grays ---------------------- */
/* Neutrals ------------------- */
/* Primary -------------------- */
/* Blue ----------------------- */
/* Kobe ----------------------- */
/* Brown ---------------------- */
/* Red ------------------------ */
/* Yellow --------------------- */
/* Green ---------------------- */
.home .api-list, .home .instruction-container .instruction-body, .home .intro-container .intro-body {
  padding-left: 2%;
  padding-right: 2%;
}

.home .card, .home {
  transition: all ease-in-out 0.25s;
}

@font-face {
  font-family: "proxima_novaregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.home {
  margin-top: 78px !important;
}
.home .heading {
  font-size: 32px;
}
.home .postBody {
  height: 100px !important;
  color: black;
}
.home .intro-container {
  display: flex;
  min-height: 480px;
  background-color: #f7f7f7;
}
.home .intro-container .intro-body {
  display: flex;
  height: 100%;
  align-items: center;
  max-width: 1264px;
  margin: auto;
}
.home .intro-container .intro-body .intro-info {
  width: 50%;
}
.home .intro-container .intro-body .intro-info .intro-heading {
  width: 60%;
  font-size: 32px;
  line-height: 48px;
}
.home .intro-container .intro-body .intro-info .intro-heading .company-name {
  background: linear-gradient(89.88deg, #ff8045 2.69%, #7bd3cf 43.19%, #ab9cee 72%, #ffbd45 99.83%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}
.home .intro-container .intro-body .intro-info .intro-description {
  width: 60%;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: #000000;
}
.home .intro-container .intro-body .intro-info .intro-action {
  display: flex;
}
.home .intro-container .intro-body .intro-info .intro-action a {
  text-decoration: none;
}
.home .intro-container .intro-body .intro-info .intro-action .button {
  height: 42px;
  line-height: 22px;
  font-size: 14px;
  padding: 0px 24px;
}
.home .intro-container .intro-body .intro-info .intro-action .button:hover {
  background-color: #4035de;
  color: #ffffff;
}
.home .intro-container .intro-body .intro-image {
  width: 50%;
}
.home .intro-container .intro-body .intro-image img {
  height: 100%;
  width: 80%;
  float: right;
}
.home .instruction-container {
  display: flex;
  background-color: white;
  padding: 15px;
  min-height: 576px;
}
.home .instruction-container .instruction-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1264px;
  margin: auto;
  height: 100%;
  text-align: center;
}
.home .instruction-container .instruction-body .api-list {
  padding-left: 0px;
  padding-right: 0px;
}
.home .instruction-container .instruction-body .card-body {
  text-align: center;
  padding: 0;
}
.home .api-container {
  padding: 100px 0px;
  text-align: center;
  background-color: #f7f7f7;
}
.home .api-container .card {
  overflow: auto;
  cursor: pointer;
}
.home .api-container .card .card-logo {
  fill: red;
}
.home .api-container .card:hover {
  background-color: #4035de;
}
.home .api-container .card:hover .card-heading {
  color: white !important;
}
.home .api-container .card:hover .card-description {
  color: white !important;
}
.home .api-container .card:hover .card-logo {
  filter: brightness(0) invert(1);
}
.home .api-list {
  max-width: 1264px;
  margin: 59px auto !important;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.home .api-list .card-heading {
  margin-top: 35px;
}
.home .api-list a {
  margin: auto;
  width: 25%;
  height: 232px;
  text-decoration: none;
}
.home .card {
  margin: 0;
  padding: 32px 32px 32px 32px;
  display: block;
  position: relative;
  text-align: left;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 11px;
  border: solid 1px transparent;
  height: 100%;
}
.home .card .card-body {
  word-wrap: break-word;
  width: auto;
  bottom: 0;
  margin: 0;
  text-align: left;
  height: 100%;
  overflow: auto;
}
.home .card .card-body .card-logo {
  fill: red;
}
.home .card .card-body .card-icon-body {
  margin: auto;
  margin-top: 11px;
  margin-bottom: 0px;
  border-radius: 50%;
  padding: 4px 6px;
  background-color: rgba(24, 172, 180, 0.2470588235);
}
.home .card .card-body .card-icon-body img {
  height: 22px;
  width: 22px;
}
.home .card .card-body .card-heading {
  color: #4a4a4a;
  width: 100%;
  margin: 0;
  font-size: 1.5rem;
  line-height: 36px;
  text-shadow: none;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  max-width: 100%;
}
.home .card .card-body .card-description {
  color: #272727;
  line-height: 24px;
  font-size: 1rem;
  margin: 16px 0 44px 0;
  overflow: hidden;
}
.home .card .card-body::-webkit-scrollbar {
  display: none;
}
.home .card::-webkit-scrollbar {
  display: none;
}
.home .footer {
  height: 98px;
  max-width: 1264px;
  margin: auto;
}
.home .footer .footer-body {
  display: flex;
  align-items: center;
  height: 100%;
}
@media (max-width: 1024px) {
  .home .intro-heading {
    width: 100% !important;
  }
  .home .intro-description {
    width: 100% !important;
  }
}
@media (max-width: 998px) {
  .home .api-list a {
    width: 42% !important;
  }
}
@media (max-width: 768px) {
  .home .intro-body {
    flex-direction: column !important;
    gap: 30px !important;
  }
  .home .intro-body .intro-info {
    width: 100% !important;
  }
  .home .intro-body .intro-image {
    width: 100% !important;
  }
  .home .intro-body .intro-image img {
    float: unset !important;
  }
}
@media (max-width: 484px) {
  .home .api-list a {
    width: 84% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/stylesheets/_normalize.scss","webpack://./src/stylesheets/_home.scss","webpack://./src/stylesheets/_font.scss","webpack://./src/stylesheets/_variables.scss","webpack://./src/stylesheets/_icon-font.scss"],"names":[],"mappings":"AAEA;EACI,2BAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;ACAJ;;ADIA;EACI,SAAA;ACDJ;;ADKA;;;;;;;;;;;;;EAaI,cAAA;ACFJ;;ADOA;;;;EAII,qBAAA,EAAA,MAAA;EACA,wBAAA,EAAA,MAAA;ACJJ;;ADQA;EACI,aAAA;EACA,SAAA;ACLJ;;ADUA;;EAEI,aAAA;ACPJ;;ADWA;EACI,6BAAA;ACRJ;;ADaA;;EAEI,UAAA;ACVJ;;ADeA;EACI,yBAAA;ACZJ;;ADgBA;;EAEI,iBAAA;ACbJ;;ADkBA;EACI,kBAAA;ACfJ;;ADoBA;EACI,cAAA;EACA,gBAAA;ACjBJ;;ADqBA;EACI,gBAAA;EACA,WAAA;AClBJ;;ADuBA;EACI,cAAA;ACpBJ;;ADyBA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ACtBJ;;ADyBA;EACI,WAAA;ACtBJ;;ADyBA;EACI,eAAA;ACtBJ;;AD8BA;EACI,SAAA;AC3BJ;;ADiCA;EACI,gBAAA;AC9BJ;;ADqCA;EACI,gBAAA;AClCJ;;ADwCA;EAEI,uBAAA;EACA,SAAA;ACrCJ;;ADwCA;;EAAA;AAIA;EACI,cAAA;ACtCJ;;ADyCA;;EAAA;AAIA;;;;EAII,2BAAA;EACA,cAAA;ACvCJ;;AD2CA;;;;;EAKI,cAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;ACxCJ;;AD2CA;;EAAA;AAIA;EACI,iBAAA;ACzCJ;;AD4CA;;;;;EAAA;AAOA;;EAEI,oBAAA;AC1CJ;;AD6CA;;;;;;EAAA;AAQA;;;;EAII,0BAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;AC3CJ;;AD8CA;;EAAA;AAIA;;EAEI,eAAA;AC5CJ;;AD+CA;;EAAA;AAIA;;EAEI,SAAA;EACA,UAAA;AC7CJ;;ADgDA;;;EAAA;AAKA;EACI,mBAAA;AC9CJ;;ADiDA;;;;;;EAAA;AAQA;;EAEI,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AC/CJ;;ADkDA;;;;EAAA;AAMA;;EAEI,YAAA;AChDJ;;ADmDA;;;;EAAA;AAMA;EACI,6BAAA,EAAA,MAAA,EAEA,MAAA;EACA,uBAAA;ACjDJ;;ADoDA;;;;EAAA;AAMA;;EAEI,wBAAA;AClDJ;;ADqDA;;EAAA;AAIA;EACI,yBAAA;EACA,aAAA;EACA,8BAAA;ACnDJ;;ADsDA;;;EAAA;AAKA;EACI,SAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;ACpDJ;;ADuDA;;EAAA;AAIA;EACI,cAAA;ACrDJ;;ADwDA;;;EAAA;AAKA;EACI,iBAAA;ACtDJ;;ADyDA;+EAAA;AAGA;;EAAA;AAIA;EACI,yBAAA;EACA,iBAAA;ACxDJ;;AD2DA;;EAEI,UAAA;ACxDJ;;ACpSA;EACI,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;AD8RJ;AC3RE;EACE,gCAAA;EACA,4CAAA;EACA,8SAAA;EAUA,mBAAA;EACA,kBAAA;ADoRJ;AChRE;EACE,mCAAA;EACA,gEAAA;EAEA,mBAAA;EAEA,kBAAA;ADgRJ;AC7QE;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAUA,mBAAA;EACA,kBAAA;ADsQJ;AEtRA,iCAAA;AAIA,iCAAA;AASA,iCAAA;AAWA,iCAAA;AAQA,iCAAA;AAUA,iCAAA;AASA,iCAAA;AAQA,iCAAA;AAQA,iCAAA;AAOA,iCAAA;AAyDA;EACE,gBAlDc;EAmDd,iBAnDc;AFkNhB;;AEpHA;EAKI,iCAAA;AFuHJ;;AGtVA;EACE,kCAAA;EACA,4CAAA;EACA,4SAAA;EAUA,mBAAA;EACA,kBAAA;AHgVF;AA1VA;EACG,2BAAA;AA4VH;AA1VE;EACE,eEyHU;AFmOd;AAtVE;EACE,wBAAA;EACA,YAAA;AAwVJ;AAtVE;EACE,aAAA;EACA,iBE+G0B;EF9G1B,yBEGK;AFqVT;AAvVI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,iBEoGS;EFnGT,YAAA;AAyVR;AAtVQ;EACI,UEqGW;AFmPvB;AAvVY;EACI,UEoGe;EFnGf,eEoImB;EFnInB,iBAAA;AAyVhB;AAxVgB;EAEI,iGAAA;EACJ,oCAAA;EACA,6BAAA;AAyVhB;AAtVY;EACI,UEyFe;EFxFf,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAwVhB;AAtVY;EACI,aAAA;AAwVhB;AAvVgB;EACI,qBAAA;AAyVpB;AAvVgB;EAEI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAwVpB;AAvVoB;EACI,yBAAA;EACA,cAAA;AAyVxB;AApVQ;EACI,UEiEY;AFqRxB;AArVY;EACI,YEiEO;EFhEP,UE+DM;EF9DN,YAAA;AAuVhB;AAlVE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,iBEwDgC;AF4RpC;AAnVI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBEuCS;EFtCT,YAAA;EACA,YAAA;EACA,kBAAA;AAqVR;AAlVQ;EACE,iBAAA;EACA,kBAAA;AAoVV;AAlVQ;EACI,kBAAA;EACA,UAAA;AAoVZ;AA/UE;EACE,kBAAA;EACA,kBAAA;EACA,yBEnFK;AFoaT;AAhVI;EACE,cAAA;EACA,eAAA;AAkVN;AAjVM;EACE,SAAA;AAmVR;AAjVM;EACE,yBAAA;AAmVR;AAlVQ;EACI,uBAAA;AAoVZ;AAlVQ;EACI,uBAAA;AAoVZ;AAlVQ;EACE,+BAAA;AAoVV;AA9UE;EAEE,iBELa;EFMb,4BAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AA+UJ;AA5UI;EACI,gBAAA;AA8UR;AA5UI;EACE,YAAA;EACA,UAAA;EACE,aAAA;EACA,qBAAA;AA8UR;AA3UA;EACI,SAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AA6UJ;AA1UI;EAEE,qBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AA2UN;AAzUM;EACE,SAAA;AA2UR;AAzUM;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AA2UR;AA1UQ;EACE,YAAA;EACC,WAAA;AA4UX;AAzUM;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;AA2UR;AAzUM;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AA2UR;AAtUI;EACE,aAAA;AAwUN;AArUE;EACE,aAAA;AAuUJ;AAnUE;EACE,YE1FgB;EF2FhB,iBE/Fa;EFgGb,YAAA;AAqUJ;AApUI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAsUN;AA/TA;EACE;IACE,sBAAA;EAiUF;EA/TA;IACI,sBAAA;EAiUJ;AACF;AA/TA;EAEI;IACE,qBAAA;EAgUJ;AACF;AA7TA;EACE;IACE,iCAAA;IACA,oBAAA;EA+TF;EA9TE;IACE,sBAAA;EAgUJ;EA9TE;IACE,sBAAA;EAgUJ;EA/TI;IAEE,uBAAA;EAgUN;AACF;AA3TA;EAGI;IACE,qBAAA;EA2TJ;AACF","sourcesContent":["\n\nhtml {\n    font-family: PoppinsRegular; /* 1 */\n    -ms-text-size-adjust: 100%; /* 2 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n\nbody {\n    margin: 0;\n}\n\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n    display: block;\n}\n\n\n\naudio,\ncanvas,\nprogress,\nvideo {\n    display: inline-block; /* 1 */\n    vertical-align: baseline; /* 2 */\n}\n\n\naudio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n\n\n[hidden],\ntemplate {\n    display: none;\n}\n\n\na {\n    background-color: transparent;\n}\n\n\n\na:active,\na:hover {\n    outline: 0;\n}\n\n\n\nabbr[title] {\n    border-bottom: 1px dotted;\n}\n\n\nb,\nstrong {\n    font-weight: bold;\n}\n\n\n\ndfn {\n    font-style: italic;\n}\n\n\n\nh1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n}\n\n\nmark {\n    background: #ff0;\n    color: #000;\n}\n\n\n\nsmall {\n    font-size: 80%;\n}\n\n\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\n\nsup {\n    top: -0.5em;\n}\n\nsub {\n    bottom: -0.25em;\n}\n\n\n\n//  * Remove border when inside `a` element in IE 8/9/10.\n \n\nimg {\n    border: 0;\n}\n\n//  * Correct overflow not hidden in IE 9/10/11.\n \n\nsvg:not(:root) {\n    overflow: hidden;\n}\n\n// /* Grouping content\n\n\n\nfigure {\n    margin: 1em 40px;\n}\n\n\n//  * Address differences between Firefox and other browsers.\n\nhr {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n}\n\n/**\n * Contain overflow in all browsers.\n */\n\npre {\n    overflow: auto;\n}\n\n/**\n * Address odd `em`-unit font size rendering in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: PoppinsRegular;\n    font-size: 1em;\n}\n\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    color: inherit; /* 1 */\n    font: inherit; /* 2 */\n    margin: 0; /* 3 */\n}\n\n/**\n * Address `overflow` set to `hidden` in IE 8/9/10/11.\n */\n\nbutton {\n    overflow: visible;\n}\n\n/**\n * Address inconsistent `text-transform` inheritance for `button` and `select`.\n * All other form control elements do not inherit `text-transform` values.\n * Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n * Correct `select` style inheritance in Firefox.\n */\n\nbutton,\nselect {\n    text-transform: none;\n}\n\n/**\n * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n *    and `video` controls.\n * 2. Correct inability to style clickable `input` types in iOS.\n * 3. Improve usability and consistency of cursor style between image-type\n *    `input` and others.\n */\n\nbutton,\nhtml input[type=\"button\"], /* 1 */\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n    -webkit-appearance: button; /* 2 */\n    cursor: pointer; /* 3 */\n}\n\n/**\n * Re-set default cursor for disabled elements.\n */\n\nbutton[disabled],\nhtml input[disabled] {\n    cursor: default;\n}\n\n/**\n * Remove inner padding and border in Firefox 4+.\n */\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n/**\n * Address Firefox 4+ setting `line-height` on `input` using `!important` in\n * the UA stylesheet.\n */\n\ninput {\n    line-height: normal;\n}\n\n/**\n * It's recommended that you don't attempt to style these elements.\n * Firefox's implementation doesn't respect box-sizing, padding, or width.\n *\n * 1. Address box sizing set to `content-box` in IE 8/9/10.\n * 2. Remove excess padding in IE 8/9/10.\n */\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    box-sizing: border-box; /* 1 */\n    padding: 0; /* 2 */\n}\n\n/**\n * Fix the cursor style for Chrome's increment/decrement buttons. For certain\n * `font-size` values of the `input`, it causes the cursor style of the\n * decrement button to change from `default` to `text`.\n */\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n}\n\n/**\n * 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n * 2. Address `box-sizing` set to `border-box` in Safari and Chrome\n *    (include `-moz` to future-proof).\n */\n\ninput[type=\"search\"] {\n    -webkit-appearance: textfield; /* 1 */\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box; /* 2 */\n    box-sizing: content-box;\n}\n\n/**\n * Remove inner padding and search cancel button in Safari and Chrome on OS X.\n * Safari (but not Chrome) clips the cancel button when the search input has\n * padding (and `textfield` appearance).\n */\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n/**\n * Define consistent border, margin, and padding.\n */\n\nfieldset {\n    border: 1px solid #c0c0c0;\n    margin: 0 2px;\n    padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct `color` not being inherited in IE 8/9/10/11.\n * 2. Remove padding so people aren't caught out if they zero out fieldsets.\n */\n\nlegend {\n    border: 0; /* 1 */\n    padding: 0; /* 2 */\n}\n\n/**\n * Remove default vertical scrollbar in IE 8/9/10/11.\n */\n\ntextarea {\n    overflow: auto;\n}\n\n/**\n * Don't inherit the `font-weight` (applied by a rule above).\n * NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n */\n\noptgroup {\n    font-weight: bold;\n}\n\n/* Tables\n   ========================================================================== */\n\n/**\n * Remove most spacing between table cells.\n */\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\ntd,\nth {\n    padding: 0;\n}\n","@charset \"utf-8\";\n@import 'normalize';\n@import 'variables';\n@import 'icon-font';\n.home {\n   margin-top: $navbar-height !important;\n    @extend %transition;\n  .heading{\n    font-size: $home-heading;\n  }\n  \n  \n  \n  \n  .postBody{\n    height:100px !important;\n    color: black;\n  }\n  .intro-container{\n    display: flex;\n    min-height: $home-intro-container-height;\n    background-color: $home-bg;\n    .intro-body{\n        display: flex;\n        height: 100%;\n        align-items: center;\n        max-width: $navbar-maxwidth;\n        margin: auto;\n        @extend %corner-padding;\n        \n        .intro-info{        \n            width: $home-intro-info-width;\n            .intro-heading{\n                width: $home-intro-info-heading-width;\n                font-size: $home-intro-info-heading-font-size;\n                line-height: 48px;\n                .company-name{\n                    // color: linear-gradient(red, yellow);\n                    background: linear-gradient(89.88deg,#ff8045 2.69%,#7bd3cf 43.19%,#ab9cee 72%,#ffbd45 99.83%);\n                -webkit-text-fill-color: transparent; \n                -webkit-background-clip: text; \n                }\n            }\n            .intro-description{\n                width: $home-intro-info-heading-width;\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 26px;\n                color: #000000;\n            }\n            .intro-action{\n                display: flex;                \n                a{\n                    text-decoration: none;                \n                }\n                .button{\n                    // margin: 5px;\n                    height: 42px;\n                    line-height: 22px;\n                    font-size: 14px;\n                    padding: 0px 24px;  \n                    &:hover{\n                        background-color: #4035de;\n                        color: #ffffff;\n                    }      \n                }\n            }\n        }\n        .intro-image{\n            width: $home-intro-image-width;\n            img{\n                height: $home-intro-img-height;\n                width: $home-intro-img-width;\n                float: right;\n            }\n        }\n    }\n  }\n  .instruction-container{\n    display: flex;\n    background-color: white;\n    padding: 15px;\n    min-height: $home-instruction-container-height;\n    .instruction-body{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        max-width: $navbar-maxwidth;\n        margin: auto;\n        height:100%;\n        text-align: center;\n        @extend %corner-padding;\n        \n        .api-list{\n          padding-left: 0px;\n          padding-right: 0px;\n        }\n        .card-body{\n            text-align: center;\n            padding: 0;\n          }\n    }\n    \n  }\n  .api-container{\n    padding: 100px 0px;\n    text-align: center;\n    background-color: $home-bg; \n    .card{\n      overflow: auto;\n      cursor: pointer;\n      .card-logo{\n        fill:red;\n      }\n      &:hover{\n        background-color: #4035de;\n        .card-heading{\n            color: white !important;\n        }\n        .card-description{\n            color: white !important;\n        }\n        .card-logo{\n          filter:  brightness(0) invert(1);\n        }\n      }\n    }\n  }\n  \n  .api-list{\n    // width: 80% !important;\n    max-width: $navbar-maxwidth;\n    margin: 59px auto !important;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    @extend %corner-padding;\n   \n    .card-heading{\n        margin-top: 35px;\n    }\n    a{\n      margin: auto;\n      width: 25%;\n        height: 232px;\n        text-decoration: none;\n    }\n}   \n.card{\n    margin: 0;\n    padding: 32px 32px 32px 32px;\n    display: block;\n    position: relative;\n    text-align: left;\n    background: #ffffff;\n    box-sizing: border-box;\n    border-radius: 11px;\n    border: solid 1px transparent;\n    height: 100%;\n    @extend %transition;\n    \n    .card-body{\n\n      word-wrap: break-word;\n      width: auto;\n      bottom: 0;\n      margin: 0;\n      text-align: left;\n      height: 100%;\n      overflow: auto;\n     \n      .card-logo {\n        fill: red;\n      }\n      .card-icon-body{\n        margin: auto;\n        margin-top: 11px;\n        margin-bottom: 0px;\n        border-radius: 50%;\n        padding: 4px 6px;\n        background-color: rgba(24, 172, 180, 0.247058823529412);\n        img{\n          height: 22px;\n           width: 22px;\n        }\n      }\n      .card-heading{\n        color: #4a4a4a;\n        width: 100%;\n        margin: 0;\n        font-size: 1.5rem;\n        line-height: 36px;\n        text-shadow: none;\n        text-transform: capitalize;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        -o-text-overflow: ellipsis;\n        -ms-text-overflow: ellipsis;\n        max-width: 100%;\n      }\n      .card-description{\n        color: #272727;\n        line-height: 24px;\n        font-size: 1rem;\n        margin: 16px 0 44px 0;\n        overflow: hidden;\n        // max-height: 72px;\n        // height: 72px;\n        }\n    }\n    .card-body::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  .card::-webkit-scrollbar {\n    display: none;\n  }\n  \n  \n  .footer{\n    height: $home-footer-height;\n    max-width: $navbar-maxwidth;\n    margin: auto;\n    .footer-body{\n      display: flex;\n      align-items: center;\n      height: 100%;\n    }\n  }\n  \n  \n \n  \n@media (max-width: 1024px) {\n  .intro-heading{\n    width: 100% !important;\n  }\n  .intro-description{\n      width: 100% !important;\n  }\n}\n@media (max-width: 998px) {\n  .api-list{\n    a{\n      width: 42% !important;\n    }\n  }\n}\n@media (max-width: 768px) {\n  .intro-body{\n    flex-direction: column !important;\n    gap: 30px !important;\n    .intro-info{\n      width: 100% !important;\n    }\n    .intro-image{\n      width: 100% !important;\n      img{\n       \n        float: unset !important;\n    }\n    }\n  }\n  \n}\n@media (max-width: 484px) {\n \n  .api-list{\n    a{\n      width: 84% !important;\n    }\n  }\n}\n}","@font-face {\n    font-family: \"proxima_novaregular\";\n    src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot\");\n    src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-regular/proximanova-regular-webfont.svg#proxima_novaregular\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: \"proxima_novalight\";\n    src: url(\"../font/proxima-nova-light/proximanova-light-webfont.eot\");\n    src: url(\"../font/proxima-nova-light/proximanova-light-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-light/proximanova-light-webfont.svg#proxima_novalight\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n    \n  }\n  \n  @font-face {\n    font-family: \"proxima_novasemibold\";\n    src: url(\"../font/proxima-nova-semi-bold/ProximaNova-Semibold.otf\")\n      format(\"opentype\");\n    font-weight: normal;\n    \n    font-style: normal;\n  }\n  \n  @font-face {\n    font-family: \"proxima_novabold\";\n    src: url(\"../font/proxima-nova-bold/proximanova-bold-webfont.eot\");\n    src: url(\"../font/proxima-nova-bold/proximanova-bold-webfont.eot?#iefix\")\n        format(\"embedded-opentype\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.woff2\")\n        format(\"woff2\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.woff\")\n        format(\"woff\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.ttf\")\n        format(\"truetype\"),\n      url(\"../font/proxima-nova-bold/proximanova-bold-webfont.svg#proxima_novabold\")\n        format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n    \n  }","\n@import \"_font.scss\";\n@import url(\"../Poppins.scss\");\n\n\n// BACKGROUND COLORS\n$sidewrapper-bg: #F8F8F8 !default;\n$navbar-bg: rgba(255, 255, 255, 1) !default;\n$examples-bg: #2E3336 !default;\n$code-bg: #35393C !default;\n$code-annotation-bg: #42484C !default;\n$nav-subitem-bg: white !default;\n$nav-active-bg: #0F75D4 !default;\n$nav-active-parent-bg: #1E2224 !default; // parent links of the current section\n$lang-select-border: #000 !default;\n$lang-select-bg: #42484C !default;\n$lang-select-active-bg: #3c4257 !default; // feel free to change this to blue or something\n$lang-select-pressed-bg: #111 !default; // color of language tab bg when mouse is pressed\n$main-bg: white !default;\n$aside-notice-bg: #8fbcd4 !default;\n$aside-warning-bg: #c97a7e !default;\n$aside-success-bg: #6ac174 !default;\n$search-notice-bg: #c97a7e !default;\n$sub-header-bar-bg: #4035de !default;\n$home-bg:#f7f7f7 !default;\n$sidebar-active-color:#4035de !default;\n$sidebar-active-bg-color:rgba(#4035de, 0.09) !default;\n// TEXT COLORS\n\n$main-text: #333 !default; // main content text color\n$nav-text: #222222 !default;\n$nav-active-text: #fff !default;\n$nav-active-parent-text: #fff !default; // parent links of the current section\n$lang-select-text: #FFFFFF !default; // color of unselected language tab text\n$lang-select-active-text: #fff !default; // color of selected language tab text\n$lang-select-pressed-text: #fff !default; // color of language tab text when mouse is pressed\n$navbar-text: #4035de !default;\n$sub-header-bar-text: white !default;\n$scrollbar-background-colour-active:#4035de !default;\n$scrollbar-background-colour:#97c3ca !default;\n\n\n/* Core ----------------------- */\n$PDS_black: #000000;\n$PDS_white: #ffffff;\n\n/* Grays ---------------------- */\n$GR500: #404040;\n$GR400: #525252;\n$GR300: #a2a2a2;\n$GR200: #cccccc;\n$GR100: #ebebeb;\n$GR50: #f1f3f4;\n$GR25: #f8f9fb;\n\n/* Neutrals ------------------- */\n$N600: #43515C;\n$N500: #353b46;\n$N400: #464f5e;\n$N300: #637085;\n$N200: #8c95a8;\n$N100: #aeb5c2;\n$N75: #d1d5dc;\n$N50: #e8eaee;\n$N40: #f4f6fa;\n\n/* Primary -------------------- */\n$P500: #1d3734;\n$P400: #3c6d68;\n$P300: #5ca59b;\n$P200: #58d7c9;\n$P100: #91dfd5;\n$P75: #c1e5e2;\n$P50: #d8f4f2;\n/* Blue ----------------------- */\n$B500: #0c0b3b;\n$B400: #1c1876;\n$B300: #2927b2;\n$B200: #4d3ee0;\n$B100: #7571e0;\n$B75: #a391f2;\n$B50: #cac1f2;\n$B40: #eae8fb;\n\n/* Kobe ----------------------- */\n$K500: #491f08;\n$K400: #913d1c;\n$K300: #da5c30;\n$K200: #f6814b;\n$K100: #eba47f;\n$K75: #f0c1a8;\n$K50: #f7e1d4;\n\n/* Brown ---------------------- */\n$BR500: #4a350f;\n$BR400: #956727;\n$BR300: #e09e3e;\n$BR200: #f8ba4b;\n$BR100: #facd78;\n$BR75: #f5ddab;\n$BR50: #fbedd5;\n/* Red ------------------------ */\n$R500: #c40f24;\n$R400: #ef233c;\n$R300: #f14458;\n$R200: #f36374;\n$R100: #f9b1b9;\n$R75: #fcd9dd;\n\n/* Yellow --------------------- */\n$Y500: #ba4800;\n$Y400: #df6e38;\n$Y300: #ff8b00;\n$Y200: #ffcd92;\n$Y100: #fffae6;\n\n/* Green ---------------------- */\n$G500: #006644;\n$G400: #00875a;\n$G300: #36b37e;\n$G200: #85dbbe;\n$G100: #e6f9f3;\n\n// SIZES\n$corner-padding:2% !default;\n$nav-width: 279px !default; // width of the navbar\n$navbar-maxwidth:1264px !default;\n$navbar-height:78px !default;\n\n$home-heading:32px !default;\n$home-footer-height:98px !default;\n$home-intro-container-height: 480px !default;\n$home-intro-info-width:50% !default;\n$home-intro-info-heading-width:60% !default;\n$home-intro-image-width:50% !default;\n$home-intro-img-width:80% !default;\n$home-intro-img-height:100% !default;\n\n$home-instruction-container-height: 576px !default;\n\n$examples-width: 40% !default; // portion of the screen taken up by code examples\n$logo-margin: 0px !default; // margin below logo\n$main-padding: 28px !default; // padding to left and right of content & examples\n$nav-padding: 15px !default; // padding to left and right of navbar\n$nav-v-padding: 10px !default; // padding used vertically around search boxes and results\n$nav-indent: 10px !default; // extra padding for ToC subitems\n$code-annotation-padding: 13px !default; // padding inside code annotations\n$h1-margin-bottom: 21px !default; // padding under the largest header tags\n$tablet-width: 1024px !default; // min width before reverting to tablet size\n$phone-width: $tablet-width - $nav-width !default; // min width before reverting to mobile size\n$navbar-heading: 12px !default;\n$logo-width: 118px !default;\n$logo-height: 43px !default;\n$card-heading:20px !default;\n$outer-right-padding:40px;\n$scrollbar-width:10px !default;\n$scrollbar-height:4px !default;\n$header-content-padding-left: 18px !default;\n$header-content-padding-right: 18px !default;\n$api-method-tag-font-size: 12px !default;\n$sidewrapper-header1-size: 16px !default;\n$sidewrapper-header2-size: 16px !default;\n$header1-font-size:32px !default;\n$header2-font-size:18px !default;\n$paragraph-font-size:32px !default;\n// FONTS Size\n$home-intro-info-heading-font-size:32px !default;\n\n%default-font {\n  font-family: PoppinsRegular;\n  \n}\n\n%corner-padding{\n  padding-left: $corner-padding;\n  padding-right: $corner-padding;\n}\n%header-font {\n  @extend %default-font;\n  font-style: normal;\n}\n\n%code-font {\n  font-family: PoppinsRegular;\n  font-size: 14px;\n  line-height: 1.5;\n  \n}\n%navbar-font{\n  font-family: PoppinsRegular;\n  font-weight: 650;\n}\n%sidewraper-heading-font{\n  font-family: PoppinsRegular;\n    font-weight: 500;\n    font-style: normal;\n    font-size: 14px;\n    \n\n}\n%api-method-font{\n  font-family: PoppinsRegular;\n  font-weight: 500;\n  font-size: $api-method-tag-font-size;\n  \n\n}\n\n$proxima_nova:\"proxima_novaregular\";\n$proxima_nova_semi_bold: \"proxima_novasemibold\";\n\n$nav-footer-border-color: #666 !default;\n$search-box-border-color: #666 !default;\n\n\n\n// These settings are probably best left alone.\n\n%transition{\n  -o-transition: all ease-in-out .25s;\n    -moz-transition: all ease-in-out .25s;\n    -ms-transition: all ease-in-out .25s;\n    -webkit-transition: all ease-in-out .25s;\n    transition: all ease-in-out .25s;\n}\n%break-words {\n    word-break: break-all;\n    hyphens: auto;\n}\n\n@media (max-width: 1263px) {\n\n  $navbar-maxwidth:616px !important;\n\n}\n@media (max-width: 615px) {\n\n  $navbar-maxwidth:400px !important;\n\n}","@font-face {\n  font-family: \"proxima_novaregular\";\n  src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot\");\n  src: url(\"../font/proxima-nova-regular/proximanova-regular-webfont.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.woff\")\n      format(\"woff\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.ttf\")\n      format(\"truetype\"),\n    url(\"../font/proxima-nova-regular/proximanova-regular-webfont.svg#proxima_novaregular\")\n      format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  \n}\n\n%icon {\n  font-family: \"proxima_novaregular\";\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  \n}\n\n%icon-exclamation-sign {\n  @extend %icon;\n  content: \"\\e600\";\n}\n%icon-info-sign {\n  @extend %icon;\n  content: \"\\e602\";\n}\n%icon-ok-sign {\n  @extend %icon;\n  content: \"\\e606\";\n}\n%icon-search {\n  @extend %icon;\n  content: \"\\e607\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
